import React, { useEffect, useState } from 'react';
import * as S from '../Advances/AdvancesStyles';
import OverviewTab from './OverviewTab';
import AttendanceLogTab from './AttendanceLogTab';
import LeaveApprovalTab from './LeaveApprovalTab';
import RegularizationTab from './RegularizationTab';
import PayrollSlipTab from './PayrollSlipTab';
import { getAllProjectsService } from '../../../../services/apiaryService';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'log', label: 'Attendance Log' },
  { id: 'leaves', label: 'Leave Approval' },
  { id: 'regularization', label: 'Regularization' },
  { id: 'payroll', label: 'Payroll Slip' },
];

const TITLES = {
  overview: ['Overview', 'Attendance percentage and pending approvals across every project.'],
  log: ['Attendance Log', "Every staff member's punch record for a given date — filterable and correctable."],
  leaves: ['Leave Approval', 'Review pending leave requests before they affect anyone\'s payslip.'],
  regularization: ['Regularization', 'Approve or reject requests to correct a missed past punch.'],
  payroll: ['Payroll Slip', 'Pick a month and project, then generate each employee\'s salary slip.'],
};

/**
 * One single sidebar entry, deliberately — unlike Advances & Expenses this has no
 * separate standalone sub-pages (see LinksTab.js: this is a plain Menu.Item, not a
 * SubMenu). Same tab-bar-over-one-page layout and styled-components as
 * AdvancesExpensesHub.jsx (imported directly from ../Advances/AdvancesStyles, not
 * duplicated) so it reads as part of the same admin app.
 *
 * Deliberately much thinner than AdvancesExpensesHub: that hub does a large amount of
 * client-side reconciliation because Advances/Expenses data historically came back
 * scattered across several endpoints. The new attendance/leave/payroll backend already
 * returns properly-shaped data per endpoint (see attendanceService.js), so each tab
 * fetches exactly what it needs instead of one giant upfront fetch-and-merge.
 */
const AttendancePayrollHub = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const projs = await getAllProjectsService().catch(() => []);
      if (cancelled) return;
      const mapped = (projs || [])
        .filter(p => p.is_active !== false && p.isActive !== false && !p.deleted && !p.isDeleted)
        .map(p => ({ id: String(p._id || p.projectId || p.id), name: p.project_name || p.name || 'Project' }));
      setProjects(mapped);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <S.MainContainer>
      <S.TopBar>
        <div>
          <h1>{TITLES[activeTab][0]}</h1>
          <p>{TITLES[activeTab][1]}</p>
        </div>
      </S.TopBar>

      <S.NavSection>
        {TABS.map(tab => (
          <S.SubNavButton key={tab.id} active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)}>
            {tab.label}
          </S.SubNavButton>
        ))}
      </S.NavSection>

      {activeTab === 'overview' && <OverviewTab projects={projects} />}
      {activeTab === 'log' && <AttendanceLogTab projects={projects} />}
      {activeTab === 'leaves' && <LeaveApprovalTab />}
      {activeTab === 'regularization' && <RegularizationTab />}
      {activeTab === 'payroll' && <PayrollSlipTab projects={projects} />}
    </S.MainContainer>
  );
};

export default AttendancePayrollHub;
